import styles from './ModelQRCodePage_8.module.css'
import { QRCode } from 'antd'

import config from '../../../../config'

import { SvgLogoMetro, SvgLogoVille } from '../../../svg/SvgComponents'

function ModelQRCodePage_8({
  qrCodeUrl,
  primaryMessage,
  secondaryMessage,
  logo,
}) {
  let iconProps = {}
  let iconSizeGlobal = 120

  if (logo === '1') {
    iconProps = {
      icon: config.URL_IMG_METRO,
      iconSize: iconSizeGlobal,
    }
  } else if (logo === '2') {
    iconProps = {
      icon: config.URL_IMG_VILLE,
      iconSize: iconSizeGlobal,
    }
  } else if (logo === '3') {
    iconProps = {
      icon: config.URL_IMG_METRO,
      iconSize: iconSizeGlobal,
    }
  }

  return (
    <div
      className={styles.page}
      style={{
        width: config.PAGE_QRCODE_WIDTH,
        height: config.PAGE_QRCODE_HEIGHT,
      }}
    >
      <div className={styles.header}>
        {logo === '1' && (
          <div className={styles.content_logo}>
            <SvgLogoMetro />
          </div>
        )}
        {logo === '2' && (
          <div className={styles.content_logo}>
            <SvgLogoVille />{' '}
          </div>
        )}
        {logo === '3' && (
          <>
            <div className={styles.multilogo}>
              <div className={styles.content_logo}>
                <SvgLogoMetro />
              </div>
              <div className={styles.content_ville}>
                <SvgLogoVille />
              </div>
            </div>
          </>
        )}
      </div>

      <div className={styles.qrContainer}>
        <QRCode
          color={'#1e1d1d'}
          bordered={false}
          value={qrCodeUrl}
          size={600}
          style={{}}
          {...iconProps}
        />
      </div>

      <div className={styles.primaryMessage}>
        <div className={styles.texte_primaryMessage}>{secondaryMessage}</div>
      </div>

      <div className={styles.secondaryMessage_content}>
        <div className={styles.secondaryMessage}>{primaryMessage}</div>
      </div>
    </div>
  )
}

export default ModelQRCodePage_8
